<app-title
  title=" {{ 'PAGINA_LISTAR_SISTEMAS.TITULO' | translate }}"
></app-title>
<section>
  <form [formGroup]="filtroForm" class="n-form" (ngSubmit)="buscarSistemas()">
    <div
      class="n-container p-5 n-card2 flex flex-wrap flex-column md:flex-row md:justify-content-between row-gap-5 column-gap-4"
    >
      <p-floatLabel>
        <input pInputText id="username" formControlName="nome" />
        <label for="username" class="ng-invalide">
          {{ 'PAGINA_LISTAR_SISTEMAS.NOME' | translate }}</label
        >
      </p-floatLabel>
      <p-floatLabel>
        <p-inputNumber inputId="integeronly" formControlName="id" id="id" />
        <label for="Id" class="ng-invalide">
          {{ 'PAGINA_LISTAR_SISTEMAS.ID' | translate }}</label
        >
      </p-floatLabel>
      <p-button label="Pesquisar" type="submit" />
    </div>
  </form>
</section>
<section class="section-margin">
  <div class="n-container p-5 n-card2">
    <p-table [value]="sistemas" [tableStyle]="{'min-width': '50rem'}">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th>{{ 'PAGINA_LISTAR_SISTEMAS.NOME' | translate }}</th>
          <th>{{ 'PAGINA_LISTAR_SISTEMAS.APLICACAO' | translate }}</th>
          <th>{{ 'PAGINA_LISTAR_SISTEMAS.ACOES' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-sistema let-columns="columns">
        <tr>
          <td>{{sistema.nome}}</td>
          <td>{{sistema.aplicacao}}</td>
          <td>
            <button
              type="button"
              pButton
              pRipple
              icon="pi pi-pencil"
              (click)="selectSistema(sistema)"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
